import { render } from "./articleDetail.vue?vue&type=template&id=66321a63&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=js"
export * from "./articleDetail.vue?vue&type=script&lang=js"

import "./articleDetail.vue?vue&type=style&index=0&id=66321a63&lang=less"
import "./articleDetail.vue?vue&type=style&index=1&id=66321a63&lang=scss&scoped=true"
import "./articleDetail.vue?vue&type=style&index=2&id=66321a63&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66321a63"]])

export default __exports__